import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from '../../campaign-3-kontable/campaign-3-kontable.component';
import { ClusterHeadNewList } from 'app/views/campaign-3/models/campaign-3-customer-target.model';
import { FormFields } from '../../form-fields/form-fields.component';

@Component({
  selector: 'app-campaign-3-create-cluster-head-list',
  templateUrl: './campaign-3-create-cluster-head-list.component.html',
  styleUrls: ['./campaign-3-create-cluster-head-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3CreateClusterHeadListComponent implements OnInit {
  
  @Input() clusterHeadList: Array<any> = [];
  // Periodo dell'azione (emissione/fruizione per coupon e messaggio, date inizio/fine per le sfide):
  // se valorizzato, vengono esclusi i cluster scaduti o futuri rispetto a questo periodo invece che rispetto a "oggi".
  @Input() actionDateStart: Date = null;
  @Input() actionDateEnd: Date = null;
  @Output() clusterHeadListSelected: EventEmitter<{name: string, arrayClusterHeads: Array<ClusterHeadNewList>}> = new EventEmitter<{name: string, arrayClusterHeads: Array<ClusterHeadNewList>}>();
  @Output() clusterHeadListCancel: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('list_name') list_name: FormFields;

  listClusterHeadListSelected: Array<any> = [];
  dateFilter = Campaign3KontableComponent.DateFilter;
  customFilter = Campaign3KontableComponent.CustomFilter;
  paginationType: number = Campaign3KontableComponent.NoPagination;
  show = {
    table: false
  }
  fieldModel = {
    name: null
  }
  
  constructor() {}
  ngOnInit() {

    if(this.clusterHeadList){

      // Tiene i soli cluster che COPRONO tutto il periodo dell'azione (emissione/fruizione per
      // coupon e messaggio, date inizio/fine per le sfide): date_start <= inizio periodo e
      // date_end >= fine periodo. E' la stessa regola di getDistributionListExpiredOrFutureCluster
      // usata al "Conferma" e della validazione di kss-k7o-challenge al salvataggio. Se il periodo
      // non e' disponibile, non viene applicato alcun filtro.
      if(this.actionDateStart){
        const periodStart = new Date(this.actionDateStart);
        periodStart.setHours(0, 0, 0, 0);
        const periodEnd = this.actionDateEnd ? new Date(this.actionDateEnd) : null;
        if(periodEnd){ periodEnd.setHours(0, 0, 0, 0); }

        this.clusterHeadList = this.clusterHeadList.filter(ch => {
          // senza date non si puo' dimostrare che copra il periodo
          if(!ch.date_start || !ch.date_end){ return false; }
          const clusterDateStart = new Date(ch.date_start);
          clusterDateStart.setHours(0, 0, 0, 0);
          const clusterDateEnd = new Date(ch.date_end);
          clusterDateEnd.setHours(0, 0, 0, 0);
          if(clusterDateStart > periodStart){ return false; }   // parte dopo l'inizio del periodo
          // senza fine periodo basta che il cluster sia ancora attivo all'inizio
          if(clusterDateEnd < (periodEnd ? periodEnd : periodStart)){ return false; }
          return true;
        });
      }

      for(let ch of this.clusterHeadList){
        if(ch.rowSelected == true){
          this.listClusterHeadListSelected.push(Object.assign({},ch));
        }
      }
      this.show.table = true;
    }
  }
  onClusterHeadSelected(clusterHead: any){

    let indexInSelected = this.listClusterHeadListSelected.findIndex(x=>x.id == clusterHead.clusterHeadId);
    if(!clusterHead.rowSelected){
      if(indexInSelected>-1) this.listClusterHeadListSelected.splice(indexInSelected,1);
    }
    else if(clusterHead.rowSelected){
      if(indexInSelected==-1) this.listClusterHeadListSelected.push(clusterHead);
    }
  }
  onClickAggiungi_ModalClusterHead(){
    this.list_name.performValidation();
    if(this.fieldModel.name && this.list_name && this.list_name.valid && this.listClusterHeadListSelected && this.listClusterHeadListSelected.length){
      this.clusterHeadListSelected.emit({name: this.fieldModel.name, arrayClusterHeads: this.listClusterHeadListSelected});
    }
  }
  onClickAnnulla_ModalClusterHead(){
    this.clusterHeadListCancel.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/create-cluster-head-list/campaign-3-create-cluster-head-list.component.ts